import { redirect, createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root.js';
import { useAuthStore } from '../lib/auth.js';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    const state = useAuthStore.getState();
    if (state.accessToken && state.user) {
      throw redirect({ to: '/app' });
    }
    throw redirect({ to: '/login' });
  },
  component: () => null,
});
